import { HoldMultiDayResultFromJSON, type HoldMultiDayResult } from 'api-client';

export async function readHoldCreationError(error: unknown): Promise<{
  result: HoldMultiDayResult | null;
  message: string;
}> {
  let message = 'Unable to confirm hold creation. Please try again.';
  if (error && typeof error === 'object' && 'response' in error && error.response instanceof Response) {
    try {
      const body: unknown = await error.response.clone().json();
      if (body && typeof body === 'object') {
        if ('outcomes' in body && Array.isArray(body.outcomes) && 'created_count' in body && 'skipped_count' in body) {
          const result = HoldMultiDayResultFromJSON(body);
          return { result, message: result.message };
        }
        const details = Object.values(body).flat().filter((value): value is string => typeof value === 'string');
        if (details.length > 0) message = details.join(' ');
      }
    } catch {
      // A non-JSON failure has no authoritative per-date result to display.
    }
  } else if (error instanceof Error) {
    message = error.message;
  }
  return { result: null, message };
}
